// Packages
import ListItem from 'modules/Bookings/components/DeletedListItem';
import PropTypes from 'prop-types';

// Other
import './styles.css';

const DeletedBookingsList = ({ isLoading, items, onChange }) => {

	// Loading State
	if ( isLoading )
	{
		return (
			<div className='DeletedBookingsList'>
					<ListItem isLoading={true}/>
			</div>
		)
	}


	// Empty State
	if ( items.length === 0 )
	{
		return (
			<h3 className='opacity italic'>No bookings to show here</h3>
		)
	}


	// Data State
	return (
		<div className='DeletedBookingsList'>
			<div className="tr-header">
				<span className="th">Booking # / Date</span>
				<span className="th">Name</span>
				<span className="th">Organisation</span>
				<span className="th right">Total</span>
				<span className="th centre">Restore</span>
			</div>

			{items.map((item, index) => {

				return (
						<ListItem 
							{...item} 
							key={index}
							isLoading={false}
							onChange={() => {onChange()}}
						/>
				)
				
			})}
	
		</div>
	)
}

DeletedBookingsList.propTypes = {
	isLoading: PropTypes.bool,
	items: PropTypes.array,
	onChange: PropTypes.func,
}

DeletedBookingsList.defaultProps = {
	isLoading: false,
	items: [],
	onChange: () => {'onChange is not set!'},
}

export default DeletedBookingsList;